import React from 'react';
import { latestFilters, type LatestFilter } from '../../utils/latestProjects';
interface LatestProjectsFilterBarProps {
  active: LatestFilter;
  counts: Record<LatestFilter, number>;
  onChange: (filter: LatestFilter) => void;
}
export function LatestProjectsFilterBar({
  active,
  counts,
  onChange
}: LatestProjectsFilterBarProps) {
  return <div role="group" aria-label="Filter latest projects" className="flex flex-wrap gap-2" data-id="element-308" data-mp="30akaqj863dc7">
      {latestFilters.map(filter => {
      const isActive = filter.id === active;
      return <button key={filter.id} type="button" aria-pressed={isActive} onClick={() => onChange(filter.id)} className={`inline-flex h-9 items-center gap-2 whitespace-nowrap border px-3 font-display text-[13px] font-bold uppercase tracking-[0.08em] transition-[background-color,border-color,color] duration-150 ease-out ${isActive ? 'border-brand-action bg-brand-action text-white' : 'border-white/20 text-steel-200 hover:border-white/50 hover:text-white'}`} data-id="element-309" data-mp="3a1eyxt4z4n0a">
            {filter.label}
            <span className={`text-[12px] ${isActive ? 'text-white/85' : 'text-steel-400'}`} data-id="element-310" data-mp="c1sjyb4xufsw">
              <span className="sr-only" data-id="element-311" data-mp="g3xedc37nggl">(</span>
              {counts[filter.id]}
              <span className="sr-only" data-id="element-312" data-mp="kxrw49z99ld1"> projects)</span>
            </span>
          </button>;
    })}
    </div>;
}